export const PlatformSelectors = {
  userDropDown: 'user-name',
  notificationsIcon: 'notification-panel-icon',
  notificationsPanel: {
    notificationsPanelMoreButton: 'notifications-more-button',
    notificationsPanel: 'notifications-panel',
  },
  userDropdownPanel: {
    notificationPreferences: 'notification-preferences',
    accountDetails: 'account-details',
    logoutButton: 'logout',
  },
};
